import { Settings, User, Menu } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface HeaderProps {
  onMenuClick?: () => void
}

export function Header({ onMenuClick }: HeaderProps) {
  return (
    <header className={cn(
      "sticky top-0 z-40 w-full",
      "border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60"
    )}>
      <div className="flex h-14 items-center px-4">
        {/* Mobile menu button */}
        <Button 
          variant="ghost" 
          size="icon"
          className="h-9 w-9 md:hidden"
          onClick={onMenuClick}
        >
          <Menu className="h-5 w-5" />
          <span className="sr-only">Toggle menu</span>
        </Button>
        
        {/* Title */}
        <div className="flex flex-1 items-center gap-4 md:ml-0">
          <h1 className="text-xl font-semibold tracking-tight">
            Portfolio Stress Testing
          </h1>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2 ml-auto">
          <Button 
            variant="ghost" 
            size="icon"
            className="h-9 w-9"
          >
            <Settings className="h-5 w-5" />
            <span className="sr-only">Settings</span>
          </Button>

          <Button 
            size="icon"
            className="h-9 w-9"
          >
            <User className="h-5 w-5" />
            <span className="sr-only">User account</span>
          </Button>
        </div>
      </div>
    </header>
  )
}
